// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tratos {
  min-height: 200px;
  margin: 0 22px 0 0;
  cursor: pointer;
  padding: 0 6px 0 5px;
}

.drop-list.cdk-drop-list-dragging app-trato:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.drop-placeholder {
  background: #ccc;
  border: dotted 3px #999;
  margin-top: 12px;
  min-height: 85px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}`, "",{"version":3,"sources":["webpack://./src/app/modulos/crm/components/pipeline/fase-columna/fase-columna.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EAEA,kBAAA;EACA,eAAA;EACA,oBAAA;AAAD;;AAKA;EACE,sDAAA;AAFF;;AAKA;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sDAAA;AAFF","sourcesContent":[".tratos {\r\n\tmin-height: 200px;\r\n\t// width: 250px;\r\n\tmargin: 0 22px 0 0 ;\r\n\tcursor: pointer;\r\n\tpadding: 0 6px 0 5px;\r\n\t// &:hover {\r\n\t// \tborder: 1px dashed rgb(177, 177, 177);\r\n\t// }\r\n}\r\n.drop-list.cdk-drop-list-dragging app-trato:not(.cdk-drag-placeholder) {\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n\r\n.drop-placeholder {\r\n  background: #ccc;\r\n  border: dotted 3px #999;\r\n  margin-top: 12px;\r\n  min-height: 85px;\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
